module.exports = __webpack_public_path__ + "static/media/instagram-footer.f0041d7d.svg";